import lodash from 'lodash';
import parsePhoneNumberFromString from 'libphonenumber-js';

export const format = {
  methods: {
    dateToText(
      date,
      formatOptions = {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }
    ) {
      let fixedDateString;

      if (lodash.isDate(date)) {
        fixedDateString = date.toISOString();
      } else {
        fixedDateString = date.replace(' ', 'T');
      }

      return new Intl.DateTimeFormat(this.$i18n.locale, formatOptions).format(
        new Date(fixedDateString)
      );
    },
    phoneFormatted(phone) {
      if (lodash.isNil(phone)) {
        return null;
      }
      const phoneNumber = parsePhoneNumberFromString(phone);
      if (lodash.isNil(phoneNumber)) {
        return null;
      }

      return {
        prefix: `+${phoneNumber.countryCallingCode}`,
        number: parseInt(phoneNumber.nationalNumber)
      };
    }
  }
};
